'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleCaption = exports.setHideCaption = exports.setShowCaption = undefined;

var _lodash = require('lodash');

var _selectionActions = require('../../element/selection/selectionActions');

var _elementActions = require('../../element/elementActions');

var _elementSelector = require('../../element/elementSelector');

var _elementCaptionUtil = require('./elementCaptionUtil');

var _analytics = require('../../analytics');

var _captionConstants = require('./captionConstants');

// Utils
var changeCaption = function changeCaption(desiredShowCaptionState) {
    return function (_ref) {
        var elementId = _ref.elementId;
        return function (dispatch, getState) {
            var state = getState();
            var element = (0, _elementSelector.getElement)(state, { elementId: elementId });

            // If already hiding the caption then no need to fire event
            if ((0, _elementCaptionUtil.getShowCaption)(element) === desiredShowCaptionState) return;

            dispatch((0, _elementActions.updateElement)({
                id: elementId,
                changes: { showCaption: desiredShowCaptionState }
            }));
        };
    };
};

// Constants
// Actions
var setShowCaption = exports.setShowCaption = changeCaption(true);
var setHideCaption = exports.setHideCaption = changeCaption(false);

var toggleCaption = exports.toggleCaption = function toggleCaption() {
    return function (dispatch, getState) {
        var state = getState();
        var elementId = state.getIn(['app', 'selection', 'ids']).first();
        var element = state.get('elements').get(elementId);

        var showingCaption = (0, _elementCaptionUtil.getShowCaption)(element);

        var addedRemoved = showingCaption ? 'removed' : 'added';
        (0, _analytics.analyticsEvent)(addedRemoved + '-' + element.get('elementType') + '-caption');

        dispatch((0, _elementActions.updateElement)({
            id: elementId,
            changes: { showCaption: !showingCaption }
        }));

        // Need to use a timeout so that the hiding & showing of the caption occurs AFTER the simpleTextEditor
        // performs its content updates.  Otherwise undo / redo would not be seen by the user.
        (0, _lodash.defer)(function () {
            if (!showingCaption) {
                dispatch((0, _selectionActions.startEditingElement)({ id: elementId, editorKey: _captionConstants.CAPTION_EDITOR_KEY }));
            } else {
                dispatch((0, _selectionActions.finishEditingElement)());
            }
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/caption/captionActions.js
// module id = 677
// module chunks = 0